import { Button, Icon } from "components/common";
import useBottomSheet from "hooks/common/useBottomSheet";
import { useEffect } from "react";

const SearchBonusPromo = () => {
  const { sheets, close } = useBottomSheet();
  const sheet = sheets.SearchBonusPromo;
  const { productId, isSpecial = false, bonusRatio = 0 } = sheet.data;
  const product = PageShop.getProductDetails(productId);
  const title = isSpecial ? 'SPECIAL OFFER' : 'BONUS COINS';
  const stitleStyle = isSpecial
    ? {
        background:
          'linear-gradient(90deg, var(--semantic-global-base-txt-primary) 0%, var(--semantic-lovematch-base-txt-default) 50%, var(--semantic-video-base-txt-default) 100%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }
    : {};

  useEffect(() => {
    return () => {
      PurchaseManager.detach();
      PageShop.resetPromo();
    };
  }, []);

  const onPurchase = () => {
    if (bonusRatio > 0) {
      Braze.applyPageShopProtocol(new URL(`thebermuda://deeplink/promo?bonus_ratio=${bonusRatio}`));
    }
    PurchaseManager.attach((err, coin, productId) => {
      if (err) return;
      close(sheet.id);

      ba('search_promo', undefined, {
        fbUid: myinfo.fbUid,
        country: myinfo.country,
        gender: myinfo.gender,
        actionType: 'purchase-success',
        productId: productId,
        bonusRatio: bonusRatio,
        randomNum: isSpecial ? 1 : 2,
        currentCoin: MyDataManager.getCoin(),
        purchaseCount: MyDataManager.getPurchaseCount(),
        lastPurchaseAmount: window.lastPurchaseInfo?.amount ?? 0,
        roomState: RoomUI.getState(),
      });
    });
    PurchaseManager.buyCoin(productId);
  };

  return (
    <div className="flex flex-col">
      <div className="relative flex flex-col items-center overflow-hidden rounded-xl bg-dialog-bg-default">
        <div className="absolute left-0 top-0 h-full w-full">
          <img className="h-full w-full object-cover" alt="" src={`/imgweb/promo/bg_promo_shortage_${isSpecial ? 'special' : 'normal'}.webp`} />
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-[20%] w-full" style={{ background: 'linear-gradient(180deg, rgba(16, 16, 28, 0.00) -34.17%, #10101C 100%)' }} />
        <div className="z-10 flex w-full flex-col items-center p-4">
          <div className="mb-4 h-1 w-8 rounded-full" style={{ backgroundColor: 'var(--semantic-global-dialog-bg-handle)' }} />
          <div className="typography-title-xl text-center" style={stitleStyle}>
            {title}
          </div>
          <div className="h-[40dvh]" />
          <div className="flex w-full flex-col items-center justify-center gap-2 rounded-lg bg-base-bg-strong px-4 py-1">
            <div className="typography-title-xl flex items-end">
              {product.amount}
              <span className="text-base-txt-video-default mx-1">+{product.amount * (bonusRatio / 100)}</span>
              <span className="typography-headline-lg">Coins</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="typography-body-sm text-base-txt-tertiary line-through">
                {product.price_currency_code}

                {((product.price_amount_micros / 1000000) * (1 + bonusRatio / 100)).toFixed(2)}
              </span>
              <span className="typography-body-lg">{product.price}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="h-2" />
      <div className="flex gap-1">
        <Button onClick={onPurchase} style={{ text: brsc.purchase, color: 'btn-bg-video-primary', fontColor: 'btn-txt-video-primary' }} />
        <div onClick={() => close(sheet.id)} className="flex h-[56px] w-[56px] items-center justify-center bg-btn-bg-normal p-2" style={{ borderRadius: '8px 32px 32px 8px' }}>
          <Icon name="icons/ic_close.svg" color="filter-base-ic-white" size={32} />
        </div>
      </div>
    </div>
  );
};

export default SearchBonusPromo;